import { MessageDescriptor, defineMessages } from 'react-intl';

export const msgs = defineMessages({
  immerseCta: {
    defaultMessage: 'Register to watch',
  },
  membotCta: {
    defaultMessage: 'Chat with MemBot',
  },
  interestingContentMobileCta: {
    defaultMessage: 'Register to learn',
  },
});

type LocalizedMessages = {
  interestingContentText: MessageDescriptor;
  interestingContentCta: MessageDescriptor;
};

export const da: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Danish with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Danish',
  },
});

export const de: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn German with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn German',
  },
});

export const el: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Greek with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Greek',
  },
});

export const en: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn English with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn English',
  },
});

export const en_us: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn English (US) with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn English (US)',
  },
});

export const es: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Spanish with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Spanish',
  },
});

export const es_mx: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Spanish (Mexico) with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Spanish (Mexico)',
  },
});

export const fa: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Persian with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Persian',
  },
});

export const fr: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn French with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn French',
  },
});

export const he: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Hebrew with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Hebrew',
  },
});

export const hi: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Hindi with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Hindi',
  },
});

export const id: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Indonesian with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Indonesian',
  },
});

export const is: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Icelandic with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Icelandic',
  },
});

export const it: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Italian with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Italian',
  },
});

export const jp_full: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Japanese (Kanji) with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Japanese (Kanji)',
  },
});

export const jp_romaji: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Japanese (Romaji) with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Japanese (Romaji)',
  },
});

export const ko: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Korean with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Korean',
  },
});

export const mn: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Mongolian with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Mongolian',
  },
});

export const nl: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Dutch with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Dutch',
  },
});

export const no: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Norwegian with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Norwegian',
  },
});

export const pl: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Polish with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Polish',
  },
});

export const pt: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Portuguese (EU) with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Portuguese (EU)',
  },
});

export const pt_br: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Portuguese (BR) with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Portuguese (BR)',
  },
});

export const ru: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Russian with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Russian',
  },
});

export const sl: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Slovenian with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Slovenian',
  },
});

export const sv: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Swedish with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Swedish',
  },
});

export const sw: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Swahili with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Swahili',
  },
});

export const th: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Thai with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Thai',
  },
});

export const tr: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Turkish with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Turkish',
  },
});

export const uk: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Ukrainian with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Ukrainian',
  },
});

export const yo: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Yoruba with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Yoruba',
  },
});

export const zh_cn: LocalizedMessages = defineMessages({
  interestingContentText: {
    defaultMessage: 'Learn Chinese with content based on your interests',
  },
  interestingContentCta: {
    defaultMessage: 'Register to learn Chinese',
  },
});
